"use client";
import { createTheme } from "@mui/material";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#0967B1",
      dark: "#13316E",
      light: "#029ED9",
    },
    secondary: {
      main: "#DA1F6C",
      dark: "#761D47",
      light: "#DC729A",
    },
    warning: {
      main: "#ffa726",
      dark: "#f57c00",
      light: "#ffb74d",
    },
  },
  typography: {
    fontFamily: ["Helvetica", "Arial", "sans-serif"].join(","),
    h4: {
      fontSize: "28px",
    },
  },
});
